"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-result", {
    staticStyle: {
      "margin-top": "80px"
    },
    attrs: {
      status: "404",
      title: "内容不存在",
      "sub-title": "哦豁，内容不见了~"
    },
    scopedSlots: _vm._u([{
      key: "extra",
      fn: function () {
        return [_c("a-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: _vm.toHome
          }
        }, [_vm._v(" 返回首页 ")])];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;